import { render, staticRenderFns } from "./DeleteUserFinalModal.vue?vue&type=template&id=1fe450da&"
import script from "./DeleteUserFinalModal.vue?vue&type=script&lang=ts&"
export * from "./DeleteUserFinalModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports